<script setup lang="ts">
</script>

<template>
    <v-chip
        class="ml-1 text-caption text-capitalize"
        size="x-small"
    >
        <slot />
    </v-chip>
</template>

<style scoped>

</style>
